<template>
  <template v-if="image">
    <RevButtonBase
      v-if="link"
      v-bind="link"
      class="focus-visible-outline-inset-hi block overflow-hidden"
      :rel="link.rel || ''"
      :tracking
    >
      <ImageRenderer v-bind="image" :image-class />
    </RevButtonBase>

    <ImageRenderer v-else v-bind="image" :image-class />
  </template>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { ModularCardImageApiProps } from '@backmarket/http-api/src/api-specs-content/models/modular-card'
import { tw } from '@backmarket/utils/string/tw'
import { RevButtonBase } from '@ds/components/ButtonBase'

import type { BlockProps } from '../../models/content-block'
import ImageRenderer from '../../shared-components/ImageRenderer/ImageRenderer.vue'

export type ModularCardImageBlockProps = ModularCardImageApiProps & BlockProps
const props = defineProps<ModularCardImageBlockProps>()

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error', 'reset-error'])

const imageClass = computed(() => (props.rounded ? tw`rounded-lg` : ''))
</script>
